import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import { Box, Paper, Typography, Alert, Grid } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { MuiTelInput } from "mui-tel-input";
import { ReactComponent as CancelIcon } from "../../static/svg/cancel.svg";
import CustomButton from "../../components/Form/CustomButton";
import { CustomInput } from "../../components/Form/CustomInputField";
import { registerUserAndSignIn } from "../../firebase/firebaseAuth";
import { useCart } from "../../context/cart-context";
import { AuthContext } from "../../context/auth-context";

export default function SignUpModal({ modalstate, handleClose }) {
  let navigate = useNavigate();
  const [errMsg, setErrMsg] = useState("");

  const { loginUser, userUID } = React.useContext(AuthContext);

  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userPhone, setUserPhone] = useState("");

  const { setIsLoading } = useCart();

  const handleChange = (newPhone) => {
    // console.log(newPhone);
    setUserPhone(newPhone);
  };

  const handleSubmit = async (e) => {
    // prevent the form from refreshing the whole page

    setErrMsg("");

    function validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    if (userFirstName === "") {
      setErrMsg("Please input first name");
    } else if (userLastName === "") {
      setErrMsg("Please input last name");
    } else if (validateEmail(userEmail) !== true) {
      setErrMsg("Please input a valid email address");
    } else if (userPassword === "") {
      setErrMsg("Please input a valid password");
    } else {
      setIsLoading(true);

      try {
        // let userData = { firstname, lastname, email, password, role };
        // const newDoc = await createDocument("user-list", userData);
        const email = userEmail;
        const password = userPassword;
        const additionalData = {
          firstname: userFirstName,
          lastname: userLastName,
          email: userEmail,
          phone: userPhone,
          role: "user",
          address: "",
          city: "",
          state: "",
          country: "",
          zipcode: 0,
          shiPaddress: "",
          shiPcity: "",
          shiPstate: "",
          shiPcountry: "",
          shiPzipcode: 0,

          // Add other user details as needed
        };

        const user = await registerUserAndSignIn(
          email,
          password,
          additionalData
        );
        console.log("User registered and details stored in Firestore:", user);
        loginUser(user.email);
        userUID(user.uid);
        setIsLoading(false);
        handleClose();

        toast(`Profile Created with Email: ${userEmail}`, {
          type: "success",
        });
        setTimeout(() => {
          navigate("/checkout");
        }, 6000);
      } catch (error) {
        setIsLoading(false);
        setErrMsg("Error registering user");
        console.error("Error registering user:", error);
      }
    }
  };

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={modalstate}
        // onClick={closeModal}
      >
        <Paper
          elevation={3}
          className="w-[350px] md:w-[600px] p-4 rounded-md relative"
        >
          <ToastContainer />
          <Box
            className="h-6 w-fit bg-black-900 rounded-2xl flex float-right"
            onClick={handleClose}
          >
            <CancelIcon className="h-6 w-fit cursor-pointer" />
          </Box>
          <Box className="mx-auto mt-8 p-2 md:p-4 flex gap-4 md:gap-24 place-content-center">
            <div className="bg-gray-50 h-fit ">
              {/* Error Message */}
              {errMsg !== "" ? (
                <Alert variant="filled" severity="error">
                  {errMsg}
                </Alert>
              ) : null}
              {/* Error Ends */}
              <Box as="div" className=" w-full md:w-3/4 mx-auto">
                {/* <Box as="div" className="w-3/4 mx-auto"> */}

                <Typography
                  variant="h3"
                  fontWeight={400}
                  fontSize={{ xs: "25px", sm: "30px", md: "30px" }}
                  lineHeight={{ xs: "103%", sm: "105.5%" }}
                  letterSpacing={"-0.01em"}
                  color="primary"
                  className=" text-center py-4 capitalize"
                >
                  Create an account
                </Typography>

                <Grid container spacing={2} item={true} className="">
                  <Grid xs={12} sm={6} md={6} item={true}>
                    <div className="mb-6 text-center">
                      <CustomInput
                        label="First Name"
                        type="text"
                        className="w-full"
                        onChange={(e) => {
                          setUserFirstName(e.target.value);
                          setErrMsg("");
                        }}
                        value={userFirstName}
                        required
                      />
                    </div>
                  </Grid>
                  <Grid xs={12} sm={6} md={6} item={true}>
                    <div className="mb-6 text-center">
                      <CustomInput
                        label="Last Name"
                        type="text"
                        className="w-full"
                        onChange={(e) => {
                          setUserLastName(e.target.value);
                          setErrMsg("");
                        }}
                        value={userLastName}
                        required
                      />
                    </div>
                  </Grid>
                  <Grid xs={12} sm={12} md={12} item={true}>
                    <div className="mb-6 text-center">
                      <CustomInput
                        label="Email"
                        type="email"
                        className="w-full"
                        onChange={(e) => {
                          setUserEmail(e.target.value);
                          setErrMsg("");
                        }}
                        value={userEmail}
                        required
                      />
                    </div>
                  </Grid>

                  <Grid xs={12} sm={12} md={12} item={true}>
                    <div className="mb-6 text-center">
                      <MuiTelInput
                        className="w-full h-fit pb-4"
                        defaultCountry="GB"
                        value={userPhone}
                        onChange={handleChange}
                      />
                    </div>
                  </Grid>

                  <Grid xs={12} sm={12} md={12} item={true}>
                    <div className="mb-6 text-center">
                      <CustomInput
                        label="Password"
                        type="password"
                        className="w-full"
                        onChange={(e) => {
                          setUserPassword(e.target.value);
                          setErrMsg("");
                        }}
                        value={userPassword}
                        required
                      />
                    </div>
                  </Grid>
                </Grid>
                <Box className="text-end mb-3">
                  <Typography
                    variant="body"
                    fontSize={{ xs: "12px", sm: "12px", md: "12px" }}
                    lineHeight={{ xs: "185%", sm: "180%" }}
                    letterSpacing={"-0.02em"}
                    color={"primary"}
                  >
                    Already have an account?{" "}
                    <Link className=" text-red-500 underline" to={"/login"}>
                      Sign in
                    </Link>
                  </Typography>
                </Box>

                <div className="text-center mx-auto">
                  <CustomButton
                    type="submit"
                    // form="add-member-form"
                    //   loading={true}
                    sx={{ width: "150px", height: "55px" }}
                    color="secondary"
                    className="text-sm !uppercase"
                    onClick={handleSubmit}
                    // to={"/checkout"}
                    // fullWidth
                  >
                    Sign up
                  </CustomButton>
                </div>
              </Box>
            </div>
          </Box>
        </Paper>
      </Backdrop>
    </div>
  );
}
